mp.bookmark = {
    maxBookmark: 25,
    maxHistory: 30,

    init: function () {
        $('#mpToggleBookmark').on('click', mp.bookmark.toggle);

        if ($('#mpOfferDetail').length === 1 && $('#mpOfferDetail').data('ident') !== '') {
            mp.bookmark.addHistory($('#mpOfferDetail').data('ident'));
        }
    },

    toggle: function (ev) {
        ev.preventDefault();
        var ref = $(this);

        try {
            var bookmarks = [];
            var mode = 'added';

            if (typeof (Cookies.get('MP_MemorizedOffers')) !== 'undefined' && Cookies.get('MP_MemorizedOffers') !== '') {
                bookmarks = Cookies.get('MP_MemorizedOffers').split(':');
            }

            if (bookmarks.length > 0) {
                var found = false;
                for (var i in bookmarks) {
                    if (bookmarks[i] == ref.data('ident')) {
                        bookmarks.splice(i, 1);
                        found = true;
                        mode = 'removed';
                    }
                }
                if (found === false) {
                    bookmarks.push(ref.data('ident'));
                }
            } else {
                bookmarks.push(ref.data('ident'));
            }

            if (bookmarks.length > 0) {
                if (bookmarks.length > mp.bookmark.maxBookmark) {
                    bookmarks.shift();
                }

                Cookies.set('MP_MemorizedOffers', bookmarks.join(':'), {
                    expires: 30,
                    path: '/',
                    domain: '.' + document.location.hostname.replace(/^www\./, ''),
                    secure: (location.protocol === 'https:'),
                    samesite: (location.protocol === 'https:' ? 'None' : 'Lax')
                });
            } else {
                Cookies.remove('MP_MemorizedOffers', {
                    path: '/',
                    domain: '.' + document.location.hostname.replace(/^www\./, '')
                });
            }

            // Toggle des Icons
            if (mode === 'removed') {
                ref
                    .tooltip('hide')
                    .attr('data-original-title', ref.data('add')) // wg. Tooltip-Plugin
                    .removeClass('mpRemoveBookmark')
                    .addClass('mpAddBookmark')
                    .html(ref.data('add'))
                    .blur();
            } else {
                ref
                    .tooltip('hide')
                    .attr('data-original-title', ref.data('remove')) // wg. Tooltip-Plugin
                    .removeClass('mpAddBookmark')
                    .addClass('mpRemoveBookmark')
                    .html(ref.data('remove'))
                    .blur();
            }

            mp.analytics.event('bookmarkOffer', mode, ref.data('ident'));

            // Trigger für die Navi-Anzeige
            mp.nav.myBookmarks(); // FIXME: das machen wir später per Events

        } catch (e) {
            // interessiert nicht weiter, wenn das fehlschlägt
            //console.log(e);
        }
    },

    addHistory: function (ident) {
        try {
            var history = [];

            if (typeof (Cookies.get('MP_EntityHistory')) !== 'undefined' && Cookies.get('MP_EntityHistory') !== '') {
                history = Cookies.get('MP_EntityHistory').split(':');
            }

            if (history.length > 0) {
                var found = false;
                for (var i in history) {
                    if (history[i] === ident) {
                        //history.splice(i, 1); // nicht wieder rauswerfen bei einem PageReload
                        found = true;
                    }
                }
                if (found === false) {
                    history.push(ident);
                }
            } else {
                history.push(ident);
            }

            if (history.length > 0) {
                if (history.length > mp.bookmark.maxHistory) {
                    history.shift();
                }

                Cookies.set('MP_EntityHistory', history.join(':'), {
                    expires: 30,
                    path: '/',
                    domain: '.' + document.location.hostname.replace(/^www\./, ''),
                    secure: (location.protocol === 'https:'),
                    samesite: (location.protocol === 'https:' ? 'None' : 'Lax')
                });
            } else {
                Cookies.remove('MP_EntityHistory', {
                    path: '/',
                    domain: '.' + document.location.hostname.replace(/^www\./, '')
                });
            }

            // Trigger für die Navi-Anzeige
            mp.nav.mySearchHistory(); // FIXME: das machen wir später per Events

        } catch (e) {
            // interessiert nicht weiter, wenn das fehlschlägt
            //console.log(e);
        }
    }
};

$(document).ready(function () {
    mp.bookmark.init();
});